import { create } from "zustand";
import type { Config360 } from "../components/View360";
import type { CuratedConfig } from "../components/ViewCurated";
import type { FinalizeImage } from "../components/FinalizeSharePanel";

type FinalizeShareCacheKeyInput = {
  exteriorConfig: Config360;
  interiorConfig: CuratedConfig;
  modelName?: string;
};

type FinalizeShareStoreState = {
  exteriorConfig?: Config360;
  interiorConfig?: CuratedConfig;
  modelName?: string;
  images: FinalizeImage[];
  cacheKey?: string;
  getCachedImages: (
    exteriorConfig: Config360,
    interiorConfig: CuratedConfig,
    modelName?: string,
  ) => FinalizeImage[] | undefined;
  setGeneratedImages: (
    input: FinalizeShareCacheKeyInput & { images: FinalizeImage[] },
  ) => void;
};

function createFinalizeImagesCacheKey(input: FinalizeShareCacheKeyInput) {
  return JSON.stringify({
    exteriorConfig: input.exteriorConfig,
    interiorConfig: input.interiorConfig,
    modelName: input.modelName,
  });
}

export const useFinalizeShareStore = create<FinalizeShareStoreState>(
  (set, get) => ({
    exteriorConfig: undefined,
    interiorConfig: undefined,
    modelName: undefined,
    images: [],
    cacheKey: undefined,
    getCachedImages: (exteriorConfig, interiorConfig, modelName) => {
      const cacheKey = createFinalizeImagesCacheKey({
        exteriorConfig,
        interiorConfig,
        modelName,
      });
      const state = get();

      return state.cacheKey === cacheKey ? state.images : undefined;
    },
    setGeneratedImages: ({ exteriorConfig, interiorConfig, modelName, images }) =>
      set({
        exteriorConfig,
        interiorConfig,
        modelName,
        images,
        cacheKey: createFinalizeImagesCacheKey({
          exteriorConfig,
          interiorConfig,
          modelName,
        }),
      }),
  }),
);
